import { render, staticRenderFns } from "./select-channel.vue?vue&type=template&id=24a01d38&scoped=true"
import script from "./select-channel.vue?vue&type=script&lang=js"
export * from "./select-channel.vue?vue&type=script&lang=js"
import style0 from "./select-channel.vue?vue&type=style&index=0&id=24a01d38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a01d38",
  null
  
)

export default component.exports